module.exports = __webpack_public_path__ + "img/BrandProfile.b5ab8921.png";